<template>
    <v-card class="p-3">
        <div class="d-flex justify-content-between">
            <h5>Notes</h5>

            <v-btn outlined class="custom-button-primary" :disabled="loadingNote" @click="updateNote">
                <v-icon>save</v-icon>

                <v-progress-circular class="progressbar ml-2" indeterminate size="20" v-if="loadingNote"
                                     color="#808080FF" width="2">
                </v-progress-circular>

            </v-btn>
        </div>

        <v-textarea outlined auto-grow hide-details @blur="checkNoteChanges" v-model="note.content">
        </v-textarea>

        <div class="d-flex justify-content-between" style="margin-top: 15px">
            <div class="mt-auto ml-3" style="color: #6c6b6b; font-style: italic; font-size: 14px"
                 v-if="note.user && note.updated_at !== undefined">
                Modifié le {{ formatDate(note.updated_at) }} par
                {{ note.user.first_name }} {{ note.user.last_name }}
            </div>
        </div>
    </v-card>
</template>

<script>
export default {
    name: "NoteBloc",
    props: ["providerId"],
    data() {
        return {
            lastNoteValue: { content: null },
            loadingNote: false,
            note: { content: null },
        }
    },
    methods: {
        updateNote() {
            let payload = {
                providerId: this.providerId,
                note: this.note.content,
            }

            this.loadingNote = true

            this.$http.post("auth/providers/note", payload).then(res => {
                this.getNote()

                this.loadingNote = false
            })
        },
        getNote() {
            this.loadingNote = true

            this.$http.get("auth/providers/note/" + this.providerId).then(res => {
                this.note = res.body.data.note

                if (this.note === null) {
                    this.note = { content: null }
                }

                this.lastNoteValue = JSON.parse(JSON.stringify(this.note))

                this.loadingNote = false
            })
        },
        checkNoteChanges() {
            if (this.note.content !== this.lastNoteValue.content) {
                this.updateNote()
            }
        },
    },
    created() {
        this.getNote()
    },
}
</script>